export default __webpack_public_path__ + "static/media/illust-vision.75badff0.svg";